import React, { useState } from 'react';
import { Portal } from '@hub/portal';
import { Box } from '@hub/box';
import { useToken } from '@hub/design-system-base';
import Color from 'color';
import { jsx as _jsx } from "react/jsx-runtime";
export const Overlay = ({
  isOpen,
  onMouseEnter,
  megaMenuPortalRef
}) => {
  const menuOverlayZIndex = useToken('zIndices', 'menuOverlay');
  const {
    0: overlayTop,
    1: setOverlayTop
  } = useState(0);
  const OVERLAY_OFFSET = 1;
  React.useEffect(() => {
    var _megaMenuPortalRef$cu, _document, _document$querySelect, _document$querySelect2;

    if (!(megaMenuPortalRef !== null && megaMenuPortalRef !== void 0 && megaMenuPortalRef.current)) {
      return;
    }

    setOverlayTop( // Adding 1px to push the overlay down a little to be safe otherwise it may add a gray line at the edge
    (megaMenuPortalRef === null || megaMenuPortalRef === void 0 ? void 0 : (_megaMenuPortalRef$cu = megaMenuPortalRef.current) === null || _megaMenuPortalRef$cu === void 0 ? void 0 : _megaMenuPortalRef$cu.getBoundingClientRect().bottom) - (((_document = document) === null || _document === void 0 ? void 0 : (_document$querySelect = _document.querySelector('body')) === null || _document$querySelect === void 0 ? void 0 : (_document$querySelect2 = _document$querySelect.getBoundingClientRect()) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.top) || 0) + OVERLAY_OFFSET);
  }, [isOpen, megaMenuPortalRef]);
  const OverlayBackgroundColor = Color(useToken('colors', 'licorice')).alpha(0.8) // eslint-disable-line no-magic-numbers
  .rgb().string();

  if (!isOpen) {
    return null;
  }

  return /*#__PURE__*/_jsx(Portal, {
    children: /*#__PURE__*/_jsx(Box, {
      sx: {
        position: 'absolute',
        backgroundColor: OverlayBackgroundColor,
        top: overlayTop,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: menuOverlayZIndex
      },
      onMouseEnter: onMouseEnter
    })
  });
};